// Helper pentru subscribing/unsubscribing la push notifications.
// Funcționează în producție pe HTTPS. iOS 16.4+ necesită PWA instalat.

import { api } from '../api/client.js';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) output[i] = rawData.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export async function getRegistration() {
  if (!isPushSupported()) return null;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    if (regs.length > 0) return regs[0];
    // Dacă SW-ul nu e încă înregistrat de vite-plugin-pwa, îl înregistrăm manual
    return await navigator.serviceWorker.register('/sw.js', { type: 'module' });
  } catch {
    return null;
  }
}

export async function getCurrentSubscription() {
  const reg = await getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

// Returnează { subscribed: bool, reason?: string }
export async function subscribePush() {
  if (!isPushSupported()) return { subscribed: false, reason: 'not_supported' };

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { subscribed: false, reason: 'permission_denied' };

  const cfg = await api('/push/config');
  if (!cfg.enabled || !cfg.public_key) return { subscribed: false, reason: 'server_disabled' };

  const reg = await getRegistration();
  if (!reg) return { subscribed: false, reason: 'no_sw' };

  const applicationServerKey = urlBase64ToUint8Array(cfg.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }

  const json = sub.toJSON();
  await api('/push/subscribe', {
    method: 'POST',
    body: { endpoint: json.endpoint, keys: json.keys },
  });
  return { subscribed: true };
}

export async function unsubscribePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return { unsubscribed: true };
  try {
    await api('/push/unsubscribe', { method: 'POST', body: { endpoint: sub.endpoint } });
  } catch { /* ignore */ }
  await sub.unsubscribe();
  return { unsubscribed: true };
}

export async function sendTestPush() {
  return api('/push/test', { method: 'POST' });
}
